import ImageEditor from './ImageEditor';

export default ImageEditor;
// updating prettier to latest gives tremendous amount of errors
// moved to a separate PR
export { type CropData } from './ImageEditor';  // tslint:disable-line
